'use client'

import * as React from 'react'
import dynamic from 'next/dynamic'

import { useWasDownloadedState } from '@web/app/[locale]/(web)/prod/[slug]/product-asset-context'

const SuggestionsComp = dynamic(
  () => import('./suggestions').then(module => ({ default: module.SuggestionsComp })),
  {
    ssr: false,
  },
)

export function Suggestions({ children }: React.PropsWithChildren) {
  const [isOpen] = useWasDownloadedState()

  if (!isOpen) {
    return children
  }

  return (
    <>
      {children}
      <SuggestionsComp />
    </>
  )
}
